import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import appSlice from './slices/appSlice';
import verificationSlice from './slices/verificationSlice';
import adminSlice from './slices/adminSlice';

const rootReducer = combineReducers({
  authSlice,
  appSlice,
  verificationSlice,
  adminSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

export default configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    // line below enables caching functionality
    getDefaultMiddleware(),
});
